<template>
	<el-dialog title="系统提示" :visible.sync="dialogVisible" width="450px"  class="successProp" :close-on-click-modal="false">
		
		<div>
			<div class="textC"><img src="../../assets/img/tanchuang/icon-2.png" alt="" class="imgsize"></div>
			<div class="texts textC">{{tips}}</div>
		</div>
		<span slot="footer" class="dialog-footer">
			
			<el-button type="primary" @click="addbtn" class="addbtn"><img src="../../assets/img/login/xiayibu.png" alt=""> 确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		props:{
			tips:{
				type:String,
				default:'删除成功'
			}
		},
		data() {
			return {
				dialogVisible: false,
			}
		},
		methods:{
			addbtn(){
				this.dialogVisible = false
			}
		}
	}
</script>

<style lang="less">
	.successProp{
		.el-dialog .el-dialog__body{
			padding-top: 33px;
			padding-bottom: 44px;
		}
		.el-dialog .el-dialog__footer{
			padding-top: 0px;
			padding-bottom: 39px;
		}
		.texts{
				font-family: MicrosoftYaHei;
				font-size: 18px;
				font-weight: normal;
				font-stretch: normal;
				letter-spacing: 1px;
				color: #47ba6d;
				margin-top: 12px;
				
		}
		.addbtn{
			width: 140px;
				height: 40px;
				background-color: #0092f1;
				border-radius: 3px;
				padding: 0px;
				img {
					// width: 18px;
					margin-right: 2px;
				}
				&.el-button{
					padding: 12px 42px;
				}
				&>span{
					width: 100%;
					height: 100%;
					display: flex;
					align-items: center;
					align-content:space-around;
				}
		}
	.imgsize {
		width: 65px;
		// height: 75px;
	}
	}
</style>
